import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { isNonEmptyString, isNonEmptyArray } from "@cayuse/shared-react.utils.type-checks";
import { fetchAward, fetchProposal, notifyError } from 'utils';
import Checkbox from "@cayuse/shared-react.components.form.inputs.checkbox";
import LoadingIndicator from "@cayuse/shared-react.components.loading-indicator";

import styles from "./styles.css";


const SectionPicker = ({ parentId, parentType, checkedValues, setCheckedValues, setFormElements }) => {
	const [ sections, setSections ] = useState([]);
	const [ isLoading, setIsLoading ] = useState(false);

	const hasSections = isNonEmptyArray(sections);

	const onCheck = useCallback (value =>{
		const shouldAdd = !checkedValues.includes(value);
		if (shouldAdd) {
			const updatedCheckValues = [ ...checkedValues, value ];
			setCheckedValues(updatedCheckValues);
		} else {
			const updatedCheckValues = checkedValues.filter(element => element !== value);
			setCheckedValues(updatedCheckValues);
		}
	}, [ checkedValues, setCheckedValues ]);

	useEffect(()=>{
		if (isNonEmptyString(parentId)) {
			setIsLoading(true);

			const fetchFunction = parentType === "award"
				? fetchAward
				: fetchProposal;

			fetchFunction(parentId)
				.then(form => {
					const { formElements, formSections } = form;
					setSections(formSections || []);
					setCheckedValues(formSections);
					setFormElements(formElements);
				})
				.catch(error => {
					notifyError(`Unable to retrieve ${parentType} sections`, error); /* todo: confirm copy & dictionary */
				})
				.finally(() => {
					setIsLoading(false);
				});
		}
	}, [ parentId, parentType, setCheckedValues, setFormElements ]);

	return(
		<div data-component="SectionPicker" className={styles.sectionPicker}>
			{isLoading
				? <LoadingIndicator />
				: hasSections // todo: undo this nested ternary, gross
					? (
						<ul className={`${styles.sectionList}`} role="group" aria-label="Select sections to copy">
							{sections
								.filter(section => isNonEmptyString(section.label))
								.map(section => (
									<li key={`section-${section.label}`}>
										<Checkbox
										          label={section.label}
												  onChange={() => onCheck(section)}
												  defaultChecked
										/>
									</li>
								))
							}
						</ul>
					)
					: (
						<span className={styles.noSectionsMessage}>
							Unable to find sections to copy, please try again or continue creating award without copying {/* todo: confirm copy & add to dictionary */}
						</span>
					)
			}
		</div>
	);
};

SectionPicker.defaultProps = {
	setFormElements: () => {}
};

SectionPicker.propTypes = {
	parentId: PropTypes.string,
	parentType: PropTypes.oneOf([ "award", "proposal" ]),
	setFormElements: PropTypes.func
};

export default SectionPicker;
